<template>
  <div id="Users">
    <MyBanner
        :text="$t('banner.accessDcPage')"
        v-if="$t('banner.accessDcPage') != ''"
    />
    <MyHeaderPage
        :title="$t('reports.cloud.title')"
        :subtitle="$t('reports.cloud.subTitle')"
    />
    <br /><br />
    <div id="TicketsList">
      <div class="listTicket">
        <!-- FILTRO -->
        <div class="mdl-grid">
          <!-- Search Input (smaller width: e.g., 3 columns) -->
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="filterTickets">
              <div class="contentInputFilter">
                <div class="contentIcon">
                  <span class="material-icons">search</span>
                </div>
                <div class="contentInput">
                  <input
                    type="text"
                    :placeholder="$t('actions.text_search_placeholder')"
                    v-model="searchString"
                    @keyup="searchByString"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Date From (3 columns) -->
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <input
                type="date"
                name="dateFrom"
                class="not-empty"
                v-model="dateFrom"
                style="background-color: white"
                @change="getList()"
              />
              <label>{{ $t("reports.filter.dateFrom") }}</label>
              <span
                class="error"
                v-if="v$.dateFrom.$invalid && v$.dateFrom.$dirty"
              >
                {{ $t("reports.filter.dateFrom") }}
                {{ $t("reports.filter.isRequired") }}
              </span>
            </div>
          </div>

          <!-- Date To (3 columns) -->
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <input
                type="date"
                name="dateTo"
                class="not-empty"
                v-model="dateTo"
                style="background-color: white"
                @change="getList()"
              />
              <label>{{ $t("reports.filter.dateTo") }}</label>
              <span class="error" v-if="v$.dateTo.$invalid && v$.dateTo.$dirty">
                {{ $t("reports.filter.dateTo") }}
                {{ $t("reports.filter.isRequired") }}
              </span>
            </div>
          </div>

          <!-- Dropdown for Project Filter (3 columns) -->
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <select
                  v-model="selectedProject"
                  @change="filterByProject"
                  style="background-color: white"
              >
                <option value="">{{ $t("reports.filter.all") }}</option>
                <option
                    v-for="(project, index) in uniqueProjects"
                    :key="index"
                    :value="project"
                >
                  {{ project }}
                </option>
              </select>
            </div>
          </div>
          <!-- CSV Export Button -->
          <div class="mdl-cell mdl-cell--2-col mdl-cell--10-offset mdl-cell--12-col-tablet mdl-cell--12-col-phone">
            <button class="cdlButton" @click="exportCsv" :disabled="!viewLoader">
              <img src="@/assets/img/download.png" alt="icon" />
              {{ $t("users.downLoadCSV") }}
            </button>
          </div>
        </div>
        <!-- FINE FILTRO -->
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--12-col">
            <br />
            <table class="cloud-report-table">
              <thead v-if="!this.$IsMobile()">
                <tr>
                  <th class="col-date">{{ $t("reports.cloud.col.colOne") }}</th>
                  <th class="col-description">
                    {{ $t("reports.cloud.col.colTwo") }}
                  </th>
                  <th class="col-hours">
                    {{ $t("reports.cloud.col.colThree") }}
                  </th>
                    <th class="col-pph">{{ $t("reports.cloud.col.colFour") }}</th>
                  <th class="col-charge">
                    {{ $t("reports.cloud.col.colFive") }}
                  </th>
                  <th class="col-project">
                    {{ $t("reports.cloud.col.colSix") }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="!this.$IsMobile() && viewLoader && pagedItems.length > 0">
                <tr
                  v-for="(item, keyItem) in pagedItems"
                  :key="keyItem"
                  :class="{ odd: keyItem % 2 }"
                >
                  <td class="col-date">{{ item.data_charge }}</td>
                  <td class="col-description">{{ item.description }}</td>
                  <td class="col-hours">{{ item.usage_hours }}</td>
                  <td class="col-pph">{{ item.usage_pph }}</td>
                  <td class="col-charge">{{ item.usage_charge }}</td>
                  <td class="col-project">{{ item.project_name }}</td>
                </tr>
              </tbody>
              
              <tbody
                v-else-if="
                  this.$IsMobile() && this.viewLoader && pagedItems.length > 0
                "
              >
                <tr :class="{ odd: keyItem % 2 }" v-for="(item, keyItem) in pagedItems" :key="keyItem">
                  <td>
                    <div><strong>{{ $t("reports.cloud.col.colOne") }}</strong></div>
                    <div>{{ item.data_charge }}</div><br />
                    <div><strong>{{ $t("reports.cloud.col.colTwo") }}</strong></div>
                    <div>{{ item.description }}</div><br />
                    <div><strong>{{ $t("reports.cloud.col.colThree") }}</strong></div>
                    <div>{{ item.usage_hours }}</div><br />
                    <div><strong>{{ $t("reports.cloud.col.colFour") }}</strong></div>
                    <div>{{ item.usage_pph }}</div><br />
                    <div><strong>{{ $t("reports.cloud.col.colFive") }}</strong></div>
                    <div>{{ item.usage_charge }}</div><br />
                    <div><strong>{{ $t("reports.cloud.col.colSix") }}</strong></div>
                    <div>{{ item.project_name }}</div>
                  </td>
                </tr>
              </tbody>
              <tbody
                  v-if="
                  itemFilter.length === 0 &&
                  viewLoader &&
                  pagedItems.length === 0
                "
              >
                <tr>
                  <td colspan="6">
                    <span class="noTickets">{{ $t("reports.noResult") }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <Paginator
              v-if="viewLoader && totalItems > 0"
              :total-page="paginatedItems"
              :current-page="currentPage"
              :itemsPerPage="itemsPerPage"
              @prev-page="beforePage"
              @next-page="nextPage"
              @change-page="changePage"
            />

            <div>
              <MyLoading :viewLoader="viewLoader" type="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyBanner from "@/components/MyBanner.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import MyLoading from "@/components/MyLoading.vue";
import "@/assets/scss/TicketsList.scss";
import moment from "moment";
import {useVuelidate} from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import Paginator from "@/components/Paginator.vue";

export default {
  name: "CReportCloud",
  components: {
    MyBanner,
    MyHeaderPage,
    MyLoading,
    Paginator
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      dateFrom: { required },
      dateTo: { required },
    };
  },
  data() {
    return {
      viewLoader: false,
      selectedProject: "",
      items: [],
      itemFilter: [],
      // Add these for pagination
      currentPage: 1,
      // perPage: 10,
      paginatedItems: 0,
      totalItems: 0,

      // For the CSV export
      isExporting: false,

      // For project names from dedicated endpoint
      projectsList: [],
      dateFrom: moment().subtract(6, "months").format("DD-MM-YYYY"),
      dateTo: moment().format("DD-MM-YYYY"),
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      searchString: "",
    };
  },
  computed: {
    uniqueProjects() {
      // Use the dedicated projects list if available, otherwise fall back to extracting from items
      return this.projectsList.length > 0
          ? this.projectsList
          : [...new Set(this.items.map((item) => item.project_name))];
    },
    totalPages() {
      return Math.ceil(this.itemFilter.length / this.itemsPerPage);
    },
    pagedItems() {
      return this.items || [];
    },
  },

  methods: {
    // New method to fetch project names from dedicated endpoint
    getProjectsList() {
      this.axios
          .get(
              this.$MyCrypto(window.VUE_APP_MISTRA_URL, 1) +
              "front/v1/report-cloud-project-names",
              { headers: this.he }
          )
          .then((response) => {
            // Extract project_names array from the response
            if (response.data && response.data.project_names) {
              this.projectsList = response.data.project_names;
            } else {
              console.error("Project names not found in response:", response.data);
            }
          })
          .catch((error) => {
            console.error("Error fetching project names:", error);
          });
    },

    getList() {
      if (!this.v$.dateFrom.$invalid && !this.v$.dateTo.$invalid) {
        this.viewLoader = false;

        let par = "";
        if (this.itemsPerPage) {
          par += "&per_page=" + this.itemsPerPage;
        }

        // Add project_name parameter if a project is selected
        if (this.selectedProject) {
          par += "&project_name=" + this.selectedProject;
        }

        // Add search parameter if exists
        if (this.searchString && this.searchString.trim() !== "") {
          par += "&search=" + this.searchString;
        }

        this.axios
            .get(
                this.$MyCrypto(window.VUE_APP_MISTRA_URL, 1) +
                "front/v1/report-cloud/?from=" +
                this.dateFrom +
                "&to=" +
                this.dateTo +
                "&page=" +
                this.currentPage +
                par,
                { headers: this.he }
            )
            .then((response) => {
            // Handle the new pagination structure
            this.items = response.data.data;
            this.currentPage = response.data.current_page;
            this.itemsPerPage = response.data.per_page;
            this.totalItems = response.data.total;
              this.paginatedItems = Math.ceil(this.totalItems / response.data.per_page);

            // Extract unique projects for the filter dropdown
            if (this.items && this.items.length > 0) {
                this.uniqueProjects = [
                  ...new Set(
                      this.items
                          .filter((item) => item.project_name)
                          .map((item) => item.project_name)
                  ),
                ];
            }

            this.viewLoader = true;
          })
            .catch((error) => {
              console.error("Error fetching report data:", error);
            this.viewLoader = true;
          });
      }
    },

    // Add this method for CSV export
    exportCsv() {
      this.isExporting = true;

      // Create URL with all current filter parameters
      const params = new URLSearchParams({
        from: this.dateFrom,
        to: this.dateTo,
        csv: true, // This triggers CSV generation in the backend
      });

      // Add search parameter if exists
      if (this.searchString && this.searchString.trim() !== "") {
        params.append("search", this.searchString);
      }

      // Add project filter if selected
      if (this.selectedProject) {
        params.append("project_name", this.selectedProject);
      }

      let par = "";
      if (this.searchString && this.searchString.trim() !== "") {
        par += "&search=" + this.searchString;
      }

      if (this.selectedProject) {
        par += "&project_name=" + this.selectedProject;
      }

      let header = {
        Authorization: "Bearer " + this.$keycloak.idToken,
        Accept: "text/csv",
      };
      this.axios
          .get(
              this.$MyCrypto(window.VUE_APP_MISTRA_URL, 1) +
              "front/v1/report-cloud/?from=" +
              this.dateFrom +
              "&to=" +
              this.dateTo +
              "&csv=true" +
              par,
              { headers: header }
          )
          .then((response) => {
          // Create a blob URL and trigger download
          const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
          link.href = url;

          // Get filename from headers or use default
            const contentDisposition = response.headers["content-disposition"];
            let filename = "cloud_report.csv";

          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch && filenameMatch.length === 2) {
              filename = filenameMatch[1];
            }
          }

            link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.isExporting = false;
        })
          .catch((error) => {
            console.error("Error downloading CSV:", error);
          this.isExporting = false;
        });
    },

    // Methods to handle pagination for the Paginator component
    changePage(page) {
      this.currentPage = page;
      this.getList();
    },

    beforePage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getList();
      }
    },

    nextPage() {
      if (this.currentPage < Math.ceil(this.totalItems / this.itemsPerPage)) {
        this.currentPage++;
        this.getList();
      }
    },

    // Update your existing searchByString method
    searchByString() {
      // Reset pagination when searching
      this.currentPage = 1;
      this.getList();
    },

    // Update your existing filterByProject method
    filterByProject() {
      // Reset pagination when filtering
      this.currentPage = 1;
      this.getList();
    },
    // 🚀 New Clearly corrected COMBINED FILTERING METHOD:
    applyFilters() {
      let filteredItems = [...this.items];

      // Filter by project explicitly:
      if (this.selectedProject) {
        filteredItems = filteredItems.filter(
            (item) => item.project_name === this.selectedProject
        );
      }

      // Now also apply search filter explicitly:
      if (this.searchString && this.searchString.trim()) {
        const query = this.searchString.trim().toLowerCase();
        filteredItems = filteredItems.filter((item) =>
            Object.values(item).some(
                (val) => val && val.toString().toLowerCase().includes(query)
          )
        );
      }

      this.itemFilter = filteredItems; // final filtered result
    },
  },
  watch: {
    // Watch if 'items' get updated, reapply filter when needed
    items() {
      // this.filterByProject();
    },
  },

  mounted() {
    // Fetch project names from dedicated endpoint
    this.getProjectsList();
    // Fetch report data
    this.getList();
  },
};
</script>
<style scoped>
.cloud-report-table {
  width: 100%;
  table-layout: fixed; /* Enables explicit column width assignments clearly */
  border-collapse: collapse; /* Extra clean look for your table */
}

.cloud-report-table th,
.cloud-report-table td {
  font-family: "Opensans-Regular";
  text-align: left;
  padding: 8px;
  border-bottom: 1px solid #e0e0e0;
  font-weight: normal; /* All table data cells clearly set to normal */
  word-wrap: break-word; /* Clearly ensures content wraps nicely */
}

/* Clearly customizing column widths */
.cloud-report-table .col-date {
  width: 14%;
}
.cloud-report-table .col-description {
  width: 34%;
} /* 👈 Wider description */
.cloud-report-table .col-hours {
  width: 12%;
}
.cloud-report-table .col-pph {
  width: 12%;
}
.cloud-report-table .col-charge {
  width: 14%;
}
.cloud-report-table .col-project {
  width: 14%;
}

/* Alternating Row Color Clearly */
.cloud-report-table tr.odd {
  background-color: #f9f9f9;
}
.pagination button {
  padding: 5px 12px;
  margin: 0 10px;
  background-color: #2196f3;
  color: white;
  border: none;
  cursor: pointer;
}

.pagination button:disabled {
  background-color: #cccccc;
  cursor: default;
}

.noTickets {
  display: block;
  text-align: center;
  padding: 10px 0;
  font-style: italic;
  color: #999;
}
</style>
